export { type Metadata, useFrontendMonitoring } from './context';
export { FrontendMonitoringProvider } from './provider';
